import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import {
    selectFields,
    secondaryFields,
    commercialFields,
    landAndHouseFields,
    luxuryFields,
    parkingFields, inputFields,
} from "../../data/Fields";

import AddObjectSelect from "../../shared/components/Select/AddObjectSelect/AddObjectSelect";
import CustomInput from "../../shared/components/CustomInput";
import EditPhotoUploader from "../../shared/components/photoUploader/EditPhotoUploader";
import MapComponents from "../../shared/components/MapComponents/MapComponents";
import s from "./styles.module.css";

const EditObject = () => {
    const token = useSelector((state) => state.auth.refresh_token);
    const navigate = useNavigate();
    const { state } = useLocation();
    const { property_type, id } = useParams();


    const initialData = state?.initialData;



    const transformedInitialData = {
        ...initialData,
        documents:
            typeof initialData.documents === "string"
                ? initialData.documents.split(",")
                : initialData.documents,
        agents: initialData.agent ? [initialData.agent.id] : [],
        document_type:
            typeof initialData.documents === "string"
                ? initialData.documents.split(",")
                : initialData.documents,
        land_type:
            initialData.land_type === "Участок"
                ? "Участок"
                : initialData.land_type === "Дом"
                    ? "Дом"
                    : initialData.land_type,
    };

    const {
        register,
        setValue,
        watch,
        handleSubmit,
        reset,
        formState: { errors },
        unregister
    } = useForm({
        defaultValues: transformedInitialData,
    });


    const [latitude, setLatitude] = useState(initialData.latitude || null);
    const [longitude, setLongitude] = useState(initialData.longitude || null);

    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [existingPhotos, setExistingPhotos] = useState(initialData.photos || []);
    const [photoError, setPhotoError] = useState("");
    const [mapError, setMapError] = useState("");
    const [deletedPhotoIds, setDeletedPhotoIds] = useState([]);


    const [data, setData] = useState({});
    const [loadingData, setLoadingData] = useState(false);
    const [loadingError, setLoadingError] = useState(null);

    const fieldsMap = {
        Коммерческая: commercialFields,
        Вторичная: secondaryFields,
        "Дома и участки": landAndHouseFields,
        Элитка: luxuryFields,
        Парковка: parkingFields,
    };

    const currentPropertyType = watch("property_type");
    const propertyType = watch("property_type");

    const landType = watch("land_type");


    const fetchData = async () => {
        setLoadingData(true);
        setLoadingError(null);

        try {
            const results = await Promise.all(
                [...selectFields, ...luxuryFields]
                    .filter((field) => field.apiKey)
                    .map(async (field) => {
                        let url = "";

                        if (field.apiKey === "district_id") {
                            url = `${process.env.REACT_APP_API_URL}/api/v1/districts`;
                        } else if (field.apiKey === "agents") {
                            url = `${process.env.REACT_APP_API_URL}/api/v1/agents`;
                        } else if (
                            field.apiKey === "residentials" &&
                            luxuryFields.some((f) => f.apiKey === "residentials")
                        ) {
                            url = `${process.env.REACT_APP_API_URL}/api/v1/residentials/get-all`;
                        } else {
                            url = `${process.env.REACT_APP_API_URL}/api/v1/${field.apiKey}/`;
                        }

                        const response = await fetch(url);
                        if (!response.ok) {
                            throw new Error(`Ошибка: ${response.statusText}`);
                        }

                        let data = await response.json();

                        if (field.apiKey === "district_id") {
                            data = data.map((region) => ({
                                title: region.name,
                                districts: region.Districts.map((district) => ({
                                    value: district.ID,
                                    label: district.name,
                                })),
                            }));
                        }

                        if (field.apiKey === "residentials") {
                            const residentialData = data.map((residential) => ({
                                title: residential.name,
                                residential: residential.Residential.map((residentialItem) => ({
                                    value: residentialItem.ID,
                                    label: residentialItem.name,
                                })),
                            }));

                            if (luxuryFields.some((f) => f.apiKey === "residentials")) {
                                return { [field.apiKey]: residentialData || [] };
                            } else {
                                return { [field.apiKey]: [] };
                            }
                        }


                        return { [field.apiKey]: data || [] };
                    })
            );

            const additionalFieldResults = await Promise.all(
                [
                    ...commercialFields,
                    ...secondaryFields,
                    ...landAndHouseFields,
                    ...luxuryFields,
                    ...parkingFields,
                ]
                    .filter((field) => field.apiKey)
                    .map(async (field) => {
                        const url =
                            field.apiKey === "residentials"
                                ? `${process.env.REACT_APP_API_URL}/api/v1/residentials/get-all`
                                : `${process.env.REACT_APP_API_URL}/api/v1/${field.apiKey}/`;

                        const response = await fetch(url);
                        if (!response.ok) {
                            throw new Error(`Ошибка: ${response.statusText}`);
                        }
                        const data = await response.json();


                        return { [field.apiKey]: data || [] };
                    })
            );



            const combinedResults = results.concat(additionalFieldResults);
            setData(combinedResults.reduce((acc, item) => ({ ...acc, ...item }), {}));
        } catch (error) {
            setLoadingError(error.message);
        } finally {
            setLoadingData(false);
        }
    };


    const handleRemoveExistingPhoto = (photoId) => {
        setDeletedPhotoIds((prevIds) => [...prevIds, photoId]);
    };


    useEffect(() => {
        fetchData();
    }, []);


    const onSubmit = async (formData) => {
        if (landType === "Участок") {
            // Если area нет, отправляем 0 или пустую строку
            if (!formData.area) {
                formData.area = 0;
            }
        }

        if (selectedPhotos.length === 0 && existingPhotos.length === 0) {
            toast.error("Добавьте хотя бы одно фото!");
            setPhotoError("Добавьте хотя бы одно фото!");
            return;
        } else {
            setPhotoError("");
        }

        if (!latitude || !longitude) {
            toast.error("Выберите местоположение на карте!");
            setMapError("Выберите местоположение на карте!");
            return;
        } else {
            setMapError("");
        }


        const formDataToSend = new FormData();
        // Задаём поля, которые не нужно отправлять
        const excludedFields = ["created_at", "id", "agent", "photo", "photos"];



        Object.entries(formData).forEach(([key, value]) => {
            if (JSON.stringify(value) === JSON.stringify(transformedInitialData[key])) {
                return;
            }
            // Пропускаем поля, которые не нужны
            if (excludedFields.includes(key)) return;

            // Если поле "documents", объединяем массив в строку и отправляем под ключом "document_type"
            if (key === "documents" && Array.isArray(value)) {
                const joinedDocuments = value.join(",");
                formDataToSend.append("documents", joinedDocuments);
            } else if (Array.isArray(value)) {
                // Для остальных массивов добавляем каждое значение с ключом с []
                value.forEach((val) => formDataToSend.append(`${key}[]`, val));
            } else {
                formDataToSend.append(key, value);
            }
        });

        selectedPhotos.forEach((file) => formDataToSend.append("add_photos", file));

        // Если у вас есть массив идентификаторов удалённых фото, например, deletedPhotoIds,
        // то отправляем их, например, как массив с ключом "delete_photos[]"
        if (deletedPhotoIds && deletedPhotoIds.length > 0) {
            formDataToSend.append("delete_photos", JSON.stringify(deletedPhotoIds));
        }


        // Добавляем дополнительные данные
        formDataToSend.append("latitude", parseFloat(latitude));
        formDataToSend.append("longitude", parseFloat(longitude));

        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/v1/property/update_property/${property_type}/${id}`,
            {
              method: "PATCH",
              headers: { Authorization: `Bearer ${token}` },
              body: formDataToSend,
            }
          );

          if (!response.ok) throw new Error("Ошибка обновления");

          toast.success("Объект успешно обновлён!");
          navigate(`/objectDetails/${property_type}/${id}`);
        } catch (error) {
          toast.error("Ошибка при обновлении объекта");
        }
    };

    useEffect(() => {
        if (landType === "Участок") {
            unregister("rooms");
            unregister("furniture");
            unregister("area");
        }
    }, [landType]);


    const renderField = (field) => {

        if (
            landType === "Участок" &&
            ["rooms", "furniture", "area"].includes(field.name)
        ) {
            return null;
        }

        if (field.type === "select") {
            let options = [];
            if (field.selectOptions) {
                options = field.selectOptions;
            }
            if (data[field.apiKey]) {
                if (field.apiKey === "district_id" || field.apiKey === "residentials") {
                    options = data[field.apiKey];
                } else if (field.apiKey === "agents") {
                        options = data[field.apiKey].map((item) => ({
                        value: item.id,
                        label: item.name,
                    }));
                } else if (field.apiKey === "document_type") {
                    options = data[field.apiKey].map((item) => ({
                        value: String(item.ID),
                        label: item.name,
                    }));
                } else {
                    options = data[field.apiKey].map((item) => ({
                        value: item.name,
                        label: item.ID || item.id,
                    }));
                }
            }


            return (
                <AddObjectSelect
                    key={field.name}
                    name={field.name}
                    label={field.label}
                    placeholder={field.placeholder}
                    selected={watch(field.name)}
                    setSelected={(value) => setValue(field.name, value)}
                    options={options}
                    apiKey={field.apiKey}
                    {...register(field.name, field.validation)}
                />
            );
        }

        return (
            <CustomInput
                key={field.name}
                name={field.name}
                label={field.label}
                placeholder={field.placeholder}
                type={field.type}
                {...register(field.name)}
            />
        );
    };


    const renderDynamicFields = () => {
        const fields = fieldsMap[propertyType] || [];
        return fields
            .filter((field) => field.name !== "land_type")
            .map((field) => renderField(field, data));
    };


    if (loadingData) {
        return (
            <div className="loadingContainer">
                <div className="loader"></div>
            </div>
        );
    }
    if (loadingError) {
        return (
            <div className="errorDataBox">
                <p>{loadingError}</p>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={s.form}>
            <div className='container'>
                <h1>Редактировать объект</h1>

                <div className={s.row} style={{marginBottom: 20}}>
                    {/* Тип недвижимости */}
                    {renderField(selectFields.find((f) => f.name === "property_type"), data)}

                    {propertyType === "Дома и участки" &&
                        renderField(landAndHouseFields.find((f) => f.name === "land_type"), data)}
                    {selectFields
                        .filter((field) => field.name !== "property_type")
                        .map((field) => renderField(field, data))}
                </div>
                <MapComponents
                    latitude={latitude}
                    longitude={longitude}
                    setLatitude={setLatitude}
                    setLongitude={setLongitude}
                    mapError={mapError}
                    setMapError={setMapError}
                />

                <div className={s.row}>
                    {inputFields.map((field) => renderField(field, data))}
                    {renderDynamicFields()}

                </div>

                <EditPhotoUploader
                    onPhotosChange={setSelectedPhotos}
                    setPhotoError={setPhotoError}
                    photoError={photoError}
                    existingPhotos={existingPhotos}
                    onRemoveExistingPhoto={handleRemoveExistingPhoto}

                />

                <div className={s.editBtnWrapper}>
                    <button type="submit" className={s.editBtn}>
                        Сохранить изменения
                    </button>
                </div>
            </div>
        </form>
    );
};

export default EditObject;
